export default {"src":"/_next/static/media/address_pin.99a78422.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};